import React, { Component } from "react";
import { connect } from "react-redux";
import CustomSnackBar from "./CustomSnackBar";
import firebase from "../../utils/firebaseConfig";

class AutoUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      firebaseVersion: null,
      reloaded: false,
      timeout: 30000
    };
  }

  componentDidMount() {
    this.fetchCurrentVersionFromFirebase();
  }

  fetchCurrentVersionFromFirebase = () => {
    const dbRef = firebase.database();
    const status = dbRef.ref().child("web/foodbook/fbVersion");
    status.on("value", snapshot => {
      this.checkVersion(snapshot.val());
    });

    const timeout = dbRef.ref().child("web/foodbook/timeout");
    timeout.on("value", snapshot => {
      this.setState({ timeout: snapshot.val() });
    });
  };

  checkVersion = firebaseVersion => {
    const currentVersion = localStorage.getItem("currentVersion");
    if (currentVersion && firebaseVersion > currentVersion) {
      this.setState({ open: true, firebaseVersion });
    }
    localStorage.setItem("currentVersion", firebaseVersion);
  };

  updatePage = () => {
    document.location.reload();
  };

  handleClose = () => {
    const { timeout } = this.state;
    this.setState({ open: false });
    setTimeout(() => {
      this.setState({ open: true });
    }, timeout);
  };

  render() {
    return (
      <CustomSnackBar
        open={this.state.open}
        message="Update Available"
        buttonText="Refresh"
        handleClose={this.handleClose}
        handleClick={this.updatePage}
      />
    );
  }
}

export default AutoUpdate;



// WEBPACK FOOTER //
// ./src/components/Utils/AutoUpdate.js